import(/* webpackMode: "eager" */ "D:\\Portfolio_Programacao\\GitHub\\Renata-Landing-Page-Version-2\\app\\page.tsx");
